import { lazy } from 'react';
import { loadReducersAndSagas } from '../../../services/LazyLoadComponent';

export default lazy(() => import(/* webpackChunkName: 'ObjectiveClone' */ '.').then(loadReducersAndSagas));
